import { apiGetDietitian, apiGetMacroAnswers } from "Root/api/apiProfile";
import { setRegisteredDietitian, setMacroAnswers } from "../../actionCreators/makeActionCreator";
export const LoadRegisteredDietitianThunk = () => async (dispatch) => {
    const data = await apiGetDietitian();
    dispatch(setRegisteredDietitian(data));
};
export const LoadMacroAnswersThunk = () => async (dispatch) => {
    const data = await apiGetMacroAnswers();
    dispatch(setMacroAnswers(data.answers));
};
